import { useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import GuidedFlow from "../../primerUso/GuidedFlow";
import ImportarConfigLocal from "../../importarConfig/ImportarConfigLocal";
import { datosImportados } from "../../importarConfig/configImportada";
import useCobrosHabilitados from "../../hooks/useCobrosHabilitados";
import { SECCION_DEL_FORMULARIO, datosInicialesClub } from "./clubPayload";
import { pasosClub } from "./clubPasos";
import { guardarOpcional, publicarClub } from "./clubServicios";

const MODULO = {
  nombre: "Reservas de canchas",
  publicado: "Tus canchas ya se pueden alquilar.",
  resumenReq: "Club, ubicación, deportes, horarios, duraciones y canchas con precios",
};

/**
 * First run of Canchas (the negocio has no club yet): required steps create the club with the same
 * request as the club form and then its courts with the courts bulk upsert; optional steps complete
 * it through the update endpoint / the same bulk upsert (always with every court).
 * `onTerminar(ctx, seccion)` hands control back to the module; `seccion` is a club form section id.
 */
const CanchasGuidedFlow = ({ states, onTerminar, onCancelar }) => {
  const negocio = useSelector((s) => s.auth)?.negocio?.nombre || "";
  // Until it is known whether the account can charge, deposits stay locked.
  const { cargando, puedeCobrar } = useCobrosHabilitados();
  const senasBloqueadas = cargando || !puedeCobrar;
  const soloGratis = !cargando && !puedeCobrar;
  // Survives retries of "Abrir canchas": a club created before the courts failed is never created twice.
  const progreso = useRef({ club: null });

  const pasos = useMemo(() => pasosClub({ states, senasBloqueadas }), [states, senasBloqueadas]);
  const datosIniciales = useMemo(() => datosInicialesClub(negocio), [negocio]);

  return (
    <GuidedFlow
      modulo={MODULO}
      pasosReq={pasos.req}
      pasosOpc={pasos.opc}
      datosIniciales={datosIniciales}
      accionInicial={({ data, set }) => (
        <ImportarConfigLocal tipo="club" importado={data.importado} onImport={(config) => set(datosImportados(config))} />
      )}
      onPublicar={(d) => publicarClub(d, progreso.current, { soloGratis })}
      onGuardarOpc={(paso, d, ctx) => guardarOpcional(paso, d, ctx, { sinSenas: soloGratis })}
      onIrSeccion={(paso, ctx) => onTerminar(ctx, SECCION_DEL_FORMULARIO[paso.id] || null)}
      onIrModulo={(ctx) => onTerminar(ctx, null)}
      onCancelar={() => onCancelar(progreso.current.club)}
    />
  );
};

export default CanchasGuidedFlow;
